export function nextSlidingSlot(index: number, count: number, current: number, preferred: number): number {
  if (count < 2) return index;
  const firstTarget = preferred !== index && preferred >= 0 && preferred < count ? preferred : index === 0 ? count - 1 : 0;
  if (current === index) return firstTarget;
  if (index > 0 && index < count - 1 && current === firstTarget) return firstTarget === 0 ? count - 1 : 0;
  return index;
}
